import * as React from 'react';
import { Layout, Row, Col, Card, Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { KeyValueDisplay } from '../key_value_display/KeyValueDisplay';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	capitalize,
	currencyFormatter,
	joinList,
	joinListElements,
	optionalFilter,
} from '../../utils/DataFormatterUtils';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { fieldTechsRestCrudThunksForSupplier } from '../../thunks/field_techs_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import EditManageStockLocationsModal from './EditManageStockLocationsModal';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import WorkOrderTable from '../WorkOrderTable';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';
import { UserName } from '../name_component/user/UserNameComponent';

const { Content } = Layout;

require('./FieldTechsDetailDetailsPage.less');

const FIELD_TECH_ASSOCIATED_OPEN_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedOpenWorkOrders';
const FIELD_TECH_ASSOCIATED_WORK_HISTORY_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedWorkHistory';

class FieldTechsDetailDetailsPage extends React.Component<any, any> {
	initialPaginationActiveWorkOrders: any = {
		current: 1,
		pageSize: 3,
		pageSizeOptions: ['3', '5', '10', '25', '50'],
	};
	initialPaginationWorkHistory: any = {
		current: 1,
		pageSize: 3,
		pageSizeOptions: ['3', '5', '10', '25', '50'],
	};
	constructor(props) {
		super(props);
		this.state = {
			displayMode: 'list',
			showEditSL: false,
		};
	}

	refreshFieldTech = () => {
		const { getFieldTech, match } = this.props;
		const fieldTechId = match.params.id;
		getFieldTech(fieldTechId);
	};

	hideEditManageStockLocations = () => this.setState({ showEditSL: false });

	editManageStockLocations = () => this.setState({ showEditSL: true });

	handleManageStockLocationSuccess = () => {
		this.hideEditManageStockLocations();
		this.refreshFieldTech();
	};

	render() {
		const { fieldTech, fieldTechsFetching, history, currentUser } = this.props;

		const supervisors = nullSafeGetOrElse('inventorySupervisorContacts', fieldTech, []);
		const fieldTechDetails = {
			Role: nullSafeGet('role', fieldTech) ? capitalize(nullSafeGet('role', fieldTech)) : '--',
			'Hourly Rate': currencyFormatter()(nullSafeGet('hourlyRate', fieldTech)),
			...(nullSafeGetOrElse('length', supervisors, 0) > 0
				? {
						[`Supervisor${nullSafeGetOrElse('length', supervisors, 1) > 1 ? 's' : ''}`]:
							supervisors.map((contact, i) => (
								<span>
									<UserName contact={contact} mode={'inline'} />
									{joinListElements(supervisors.length, i)}
								</span>
							)),
				  }
				: {}),
		};

		console.log(currentUser);
		const contactDetails = {
			Email: nullSafeGet('supplierContact.email', fieldTech),
			'Work Phone': optionalFilter(nullSafeGet('supplierContact.phoneWork', fieldTech)),
			'Mobile Phone': optionalFilter(nullSafeGet('supplierContact.phoneMobile', fieldTech)),
			Fax: optionalFilter(nullSafeGet('supplierContact.fax', fieldTech)),
		};

		return (
			<Content className="fieldTechDetailDetailsPage" style={{ padding: '0 0.5em' }}>
				{fieldTechsFetching ? (
					<PageLoadingPlaceholder />
				) : (
					<div>
						<Row style={{ margin: '0 -0.5em' }} gutter={16}>
							<Col span={16}>
								<div className="rowSpacing">
									<Card title="Active Work Orders">
										<WorkOrderTable
											handleQueryParams={false}
											key={`active-work-orders-${nullSafeGet('email', fieldTech)}`}
											CustomHeader={() => <></>}
											preAppliedFilters={{
												[getWorkOrderArchivalKey(currentUser)]: false,
												isActive: true,
												fieldTechnicianEmail: nullSafeGet('email', fieldTech),
											}}
											tableStyle={{
												display: 'flex',
												flexDirection: 'column',
												cursor: 'pointer',
												userSelect: 'none',
												marginTop: '-10px',
												marginBottom: '-9px',
											}}
											initialPagination={{ current: 1, pageSize: 3 }}
											targetCollectionName={
												FIELD_TECH_ASSOCIATED_OPEN_WORK_ORDERS_TARGET_COLLECTION
											}
											renderEmptyState={() => (
												<EmptyState
													graphic={
														<img
															alt="No open active work orders found."
															style={{ marginBottom: 8 }}
															src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
														/>
													}
													headline={'No open active work orders found.'}
													body={
														<div style={{ textAlign: 'center' }}>
															<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
														</div>
													}
												/>
											)}
											backText="Back"
											openMoreInDefault
											ignoreRefreshCounts
										/>
									</Card>
								</div>

								<div className="rowSpacing">
									<Card title="Work History">
										<WorkOrderTable
											handleQueryParams={false}
											key={`work-history-${nullSafeGet('email', fieldTech)}`}
											CustomHeader={() => <></>}
											preAppliedFilters={{
												[getWorkOrderArchivalKey(currentUser)]: false,
												isActive: false,
												fieldTechnicianEmail: nullSafeGet('email', fieldTech),
											}}
											tableStyle={{
												display: 'flex',
												flexDirection: 'column',
												cursor: 'pointer',
												userSelect: 'none',

												marginTop: '-10px',
												marginBottom: '-9px',
											}}
											initialPagination={{ current: 1, pageSize: 3 }}
											targetCollectionName={FIELD_TECH_ASSOCIATED_WORK_HISTORY_TARGET_COLLECTION}
											renderEmptyState={() => (
												<EmptyState
													graphic={
														<img
															alt="No open work orders found."
															style={{ marginBottom: 8 }}
															src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
														/>
													}
													headline={'No open work orders found.'}
													body={
														<div style={{ textAlign: 'center' }}>
															<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
														</div>
													}
												/>
											)}
											backText="Back"
											ignoreRefreshCounts
										/>
									</Card>
								</div>
							</Col>
							<Col span={8}>
								<div className="rowSpacing">
									<Card title="Accessible Stock Locations">
										{nullSafeGet('hasAccessToAllStockLocations', fieldTech) ? (
											'All stock locations'
										) : nullSafeGet('accessibleStockLocations.0', fieldTech) ? (
											<div>
												{fieldTech.accessibleStockLocations.map((sl) => (
													<HyperLink
														key={`sl-${sl.id}`}
														text={sl.name}
														entityType={ENTITY_TYPE.STOCK_LOCATION}
														entityId={sl.id}
														backLinkText={'Back to Field Tech Detail'}
													/>
												))}
											</div>
										) : (
											'No Stock Location Accessible'
										)}
									</Card>
								</div>
								<div className="rowSpacing">
									<Card
										title="Managed Stock Locations"
										extra={
											<Button type="link" onClick={this.editManageStockLocations}>
												Edit
											</Button>
										}
									>
										{nullSafeGet('canManageAllStockLocations', fieldTech) ? (
											'All accessible stock locations'
										) : nullSafeGet('managedStockLocations.0', fieldTech) ? (
											<div>
												{fieldTech.managedStockLocations.map((sl) => (
													<HyperLink
														key={`sl-${sl.id}`}
														text={sl.name}
														entityType={ENTITY_TYPE.STOCK_LOCATION}
														entityId={sl.id}
														backLinkText={'Back to Field Tech Detail'}
													/>
												))}
											</div>
										) : (
											'No Stock Location Managed'
										)}
									</Card>
								</div>
								<div className="rowSpacing">
									<Card title="Problem Types">
										{nullSafeGet('problemTypes.0', fieldTech) ? (
											<div>
												{fieldTech.problemTypes.map((pt) => (
													<div key={pt.hierarchyName || pt.name}>{pt.hierarchyName || pt.name}</div>
												))}
											</div>
										) : (
											'All Problem Types'
										)}
									</Card>
								</div>
								{fieldTech.notesOnTech ? (
									<div className="rowSpacing">
										<Card title="Field Tech Notes">
											<div
												className="richTextWrapper"
												dangerouslySetInnerHTML={{ __html: fieldTech.notesOnTech }}
											/>
										</Card>
									</div>
								) : null}
								<div className="rowSpacing">
									<Card title="Field Tech Details">
										<KeyValueDisplay keyValueStore={fieldTechDetails} />
									</Card>
								</div>
								<div className="rowSpacing">
									<Card title="Contact Info">
										<KeyValueDisplay keyValueStore={contactDetails} />
									</Card>
								</div>
							</Col>
						</Row>
					</div>
				)}
				{this.state.showEditSL && (
					<EditManageStockLocationsModal
						onCancel={this.hideEditManageStockLocations}
						onSuccess={this.handleManageStockLocationSuccess}
					/>
				)}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,

	fieldTechsFetching: state.field_techs.fetching,
	fieldTech: state.field_techs.detail,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getFieldTech: (id) => dispatch(fieldTechsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(FieldTechsDetailDetailsPage)
);
